import type { FlexProps } from '@chakra-ui/react'
import { Flex } from '@chakra-ui/react'

export const FormGroup = (props: FlexProps) => (
  <Flex
    gap={4}
    _last={{ mb: 0 }}
    alignItems={{ base: 'normal', sm: 'start', md: 'normal', lg: 'start' }}
    flexDir={{ base: 'column', sm: 'row', md: 'column', lg: 'row' }}
    {...props}
  />
)
